//const storage = 'yourdemosurvey'
const storage = 'user_data_bt'
//const storage = 'user_data_obe_olu'
//const storage = 'user_data_smart'
//const storage = 'user_data_orangeromania'
//const storage = 'user_data_weetabix'
//const storage = 'user_data_victoriabank'
//const storage = 'user_data_localhost'

export function saveToStorage (userData) {
  localStorage.setItem(storage, JSON.stringify(userData))
}

export function getFromStorage () {
  let userData = localStorage.getItem(storage)
  return JSON.parse(userData)
}

export function destroyStorage () {
  localStorage.removeItem(storage)
}



// WEBPACK FOOTER //
// ./src/api/storage.js